export default __webpack_public_path__ + "static/media/mob-group.5ac277ed.png";